

import Home from './pages/home'
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
